import { createGlobalStyle } from 'styled-components'

export default createGlobalStyle`
  ${(props) => props.theme.fontUrls && props.theme.fontUrls
    .map((font: Record<string, string>) => `
      @font-face {
        font-family: '${font.name}';
        src: local('${font.localName}'),
        url('${font.url}')
      }
    `)}
`
